export default "__VITE_ASSET__l_psTtc8__"